module.exports = __webpack_public_path__ + "img/913b556.svg";